// libs
import * as React from 'react';
import i18n from 'i18next';

// components
import LabelGroup from '../../components/_UI/Forms/LabelGroup/LabelGroup';
import SupportsRichText from '../../components/Panel/PanelEditorSidebar/PanelDesign/SupportsRichText';
import ActionSliderGroup from '../../components/_UI/Forms/Actions/ActionSliderGroup';
import ActionSegmentedGroup from '../../components/_UI/Forms/Actions/ActionSegmentedGroup';
import ActionColorSwatchGroup from '../../components/_UI/Forms/Actions/ActionColorSwatchGroup';
import { Flexbox } from 'components/spaceKit';

// utils
import {
    opacityTunables,
    borderTunables,
    inheritFontCase,
} from 'components/Sidebar/RenderTunables/SharedTunables';

// constants
import { verticalAlignOptions } from 'components/Panel/PanelEditorSidebar/PanelDesign/PanelDesignOptions';

// types
import { TunablesCollapse, CollapseProps } from 'components/Sidebar/RenderTunables/RenderTunables';
import { Theme } from 'models/Theme/Theme';
import { Widget } from '@sprinklr/stories/widget/Widget';
import { CustomContentRichTextOptionsImpl } from './options';

const CustomContentRichTextTunables = (widget: Widget, mergedTheme: Theme): TunablesCollapse[] => [
    {
        props: {
            label: i18n.t('Rich Text'),
            startOpen: true,
        } as CollapseProps,
        children: [opacityTunables(widget), borderTunables(widget), inheritFontCase(widget)],
    },
    {
        props: {
            label: i18n.t('Typography'),
            startOpen: true,
        } as CollapseProps,
        children: [
            <SupportsRichText key='supportsRichText' widget={widget} mergedTheme={mergedTheme} />,
        ],
    },
    {
        props: {
            label: i18n.t('Tunables'),
            startOpen: true,
        } as CollapseProps,
        children: [
            <ActionSliderGroup
                key='widget.options.contentPadding'
                label={i18n.t('Padding')}
                option={widget.options}
                value='contentPadding'
                showValue
                min={0}
                max={100}
            />,
            <ActionSegmentedGroup
                key='widget.options.verticalAlign'
                label={i18n.t('Vertical Align')}
                option={widget.options}
                value='verticalAlign'
                options={verticalAlignOptions}
            />,
            <Flexbox gap='m' key='rich text tunable colors'>
                <LabelGroup
                    label={i18n.t('Back')}
                    key='label widget.options.contentBackgroundColor'>
                    <ActionColorSwatchGroup
                        key='widget.options.contentBackgroundColor'
                        option={widget.options}
                        value='contentBackgroundColor'
                        secondaryIcon={
                            (widget.options as CustomContentRichTextOptionsImpl)
                                .contentBackgroundColor
                        }
                    />
                </LabelGroup>
            </Flexbox>,
        ],
    },
];

export default CustomContentRichTextTunables;
